<div class="customer-list-card-container">
  <div class="customer-list-card">
    <div ubi-curve-header class="customer-list-card__header">
      <span class="customer-list-card__header-text"> {{ 'customer_list.header' | translate }} </span>
    </div>
    <artemis-popover>
      <ng-container *ngFor="let section of ('customer_list.info.content' | translate)">
        <p>{{ section.paragraph }}</p>
        <p>{{ section.header }}</p>
        <ol>
          <ng-container *ngFor="let content of section.array">
            <li>{{ content }}</li>
          </ng-container>
        </ol>
      </ng-container>
    </artemis-popover>
    <div class="customer-list-card__content-container">
      <div class="customer-list-tool-bar">
<!--         <mat-form-field class="custom-mat-form-field customer-list-tool-bar__search-field">
          <input matInput (keyup)="searchCustomerList($event.target.value)" placeholder="Search" autocomplete="off">
          <img matSuffix class="themified-white-icon customer-list-tool-bar__search-icon" src="/assets/icons/magnifying-glass-icon.png">
        </mat-form-field> -->
        <div class="customer-button customer-list-tool-bar__add-customer-btn-container">
          <button mat-button class="btn btn_blue-gradient-rounded customer-list-tool-bar__add-customer-btn" ubi-round-button [artemisDropdownToggler]="listOption">
            + {{ 'customer.button' | translate }}
          </button>
          <artemis-dropdown-menu class="dropdown_after-line" #listOption>
            <a class="right-panel__dropdown-items" dropdown-item routerLink="/customers/onboarding" title="Manual customer input">
              {{ 'customer.title.manual_input' | translate }}
            </a>
            <a class="right-panel__dropdown-items" dropdown-item routerLink="/customers/batch-upload" title="Upload file with customers">
              {{ 'customer.title.batch_upload' | translate }}
            </a>
            <a class="right-panel__dropdown-items" dropdown-item routerLink="/handshakes" title="Purchase Bizfile From Handshakes" [ngClass]="{'dropdown-item_disabled': !enableHandshakes}">
              {{ 'customer.title.purchase_bizfile_from_handshakes' | translate }}
            </a>
            <a class="right-panel__dropdown-items" dropdown-item routerLink="/opencorporates" title="Import From OpenCorporates" [ngClass]="{'dropdown-item_disabled': !enableOpenCorporates}">
              {{ 'customer.title.import_from_opencorporates' | translate }}
            </a>
          </artemis-dropdown-menu>
        </div>
        <button mat-button (click)="!isDownloadButtonClicked && getCsv()"  class="btn btn_rounded btn_need-loading customer-list-tool-bar__download-btn" ubi-round-button [disabled]="isDownloadButtonClicked && preparingDownload">
          <artemis-loading-spinner *ngIf="preparingDownload"></artemis-loading-spinner>
          {{ 'customer_list.button.download' | translate }}
        </button>
      </div>
      <div class="customer-list-container">
        <artemis-loading-spinner *ngIf="loading | async"></artemis-loading-spinner>
        <div class="customer-list-table-container">
          <table mat-table matSort class="custom-mat-table customer-list-table" [dataSource]="dataSource">
            <ng-container matColumnDef="is_active_customer">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'general.table.label.active' | translate }}</th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell">
                <img class="customer-list-table__customer-active-icon" [src]="item.isActiveCustomer? '/assets/icons/active-customer-icon.png' : '/assets/icons/inactive-cutomer-icon.png'">
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.name' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell customer-list-table__name">
                <a class="link" [routerLink]="['/customers', item.id]" title="Customer Overview">
                  <span>{{item.name}}</span>
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="record_type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.type' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell">
                <ng-container [ngSwitch]="item.isActiveCustomer">
                  <img class="themified-white-icon customer-list-table__type" *ngSwitchCase="true"
                       [src]="(item.customerType === 'INDIVIDUAL') ? '/assets/icons/individual-icon-white.png' : '/assets/icons/corporate-icon-white.png'"
                       [title]="(item.customerType === 'INDIVIDUAL') ? 'INDIVIDUAL' : 'CORPORATE'">
                  <img class="themified-white-icon customer-list-table__customer-active-icon" *ngSwitchDefault
                       [src]="(item.customerType === 'INDIVIDUAL') ? '/assets/icons/individual-icon-gray.png' : '/assets/icons/corporate-icon-gray.png'"
                       [title]="(item.customerType === 'INDIVIDUAL') ? 'INDIVIDUAL' : 'CORPORATE'">
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.status' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell"
                  [ngClass]="{'customer-list-table__cell_grey': item.status === 'DRAFT',
                              'customer-list-table__cell_accent': item.status === 'PENDING' || item.status === 'REQUEST CHANGES' || item.status === 'REQUIRE UPDATE' || item.status === 'UPDATED',
                              'customer-list-table__cell_green': item.status === 'CLEARED' || item.status === 'ACCEPTED',
                              'customer-list-table__cell_alert': item.status === 'REJECTED'}">
                {{item.status}}
              </td>
            </ng-container>
            <ng-container matColumnDef="nature_of_business_relationship" *ngIf="natureOfBusinessVisible">
              <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.nature_of_business_relationship' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell customer-list-table__nature_of_business" matTooltip="{{item.natureOfBusinessRelationship}}">
                <span> {{ item.natureOfBusinessRelationship || "-" }} </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="risk_rating">
              <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.risk_rating' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell"
                  [ngClass]="{'customer-list-table__cell_grey': item.riskRating === 'UNKNOWN',
                              'customer-list-table__cell_accent': item.riskRating === 'MEDIUM',
                              'customer-list-table__cell_green': item.riskRating === 'LOW',
                              'customer-list-table__cell_alert': item.riskRating === 'HIGH'}">
                {{item.riskRating}}
              </td>
            </ng-container>
            <ng-container matColumnDef="updated_at">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.updated_at' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell">{{item.updatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a'}}</td>
            </ng-container>
            <ng-container matColumnDef="updated_by">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.update_by' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell uppercase-text">{{item?.updatedBy?.name}}</td>
            </ng-container>
            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.actions' | translate }} </th>
              <td mat-cell *matCellDef="let item" class="customer-list-table__cell">
                <div class="customer-list-table__links-container">
                  <a mat-icon-button class="custom-mat-icon-button customer-list-table__link" [routerLink]="['/customers', item.id, 'edit']" title="Edit">
                    <img class="themified-white-icon customer-list-table__link-icon" src="/assets/icons/edit-icon.png">
                  </a>
                  <a mat-icon-button class="custom-mat-icon-button customer-list-table__link" [routerLink]="!(item.status === 'DRAFT') ? ['/customers', item.id, 'screening'] : null"
                    [class.customer-list-table__link_disabled]="item.status === 'DRAFT'" title="Screening">
                    <img class="themified-white-icon customer-list-table__link-icon" src="/assets/icons/screening-icon.png">
                  </a>
                  <div>
                    <button mat-icon-button [matMenuTriggerFor]="downloadDropdown" class="custom-mat-icon-button customer-list-table__link">
                      <img class="themified-white-icon customer-list-table__link-icon" src="/assets/icons/download-pdf-icon.png">
                    </button>
                    <mat-menu #downloadDropdown="matMenu" class="custom-mat-menu-panel">
                      <button mat-menu-item (click)="downloadAcceptanceForm(item)" title="Customer Acceptance Form">
                        {{ 'general.table.label.customer_accteptance_form' | translate }}
                      </button>
                      <button mat-menu-item (click)="downloadReport(item)" [disabled]="item.status === 'DRAFT' || item.status === 'PENDING' || item.status === 'REQUEST CHANGES' || item.status === 'REQUIRE UPDATE' || currentCustomer?.status === 'UPDATED'" title="Detailed Report">
                        {{ 'general.table.label.detailed_report' | translate }}
                      </button>
                    </mat-menu>
                  </div>
                  <a mat-icon-button [routerLink]="['/customers', item.id, 'access-control']" class="custom-mat-icon-button customer-list-table__link" title="Access Control">
                    <img class="themified-white-icon customer-list-table__link-icon" src="/assets/icons/access-control-icon.png">
                  </a>
                  <a mat-icon-button [routerLink]="['/customers', item.id, 'relationship-map']" class="custom-mat-icon-button customer-list-table__link" title="Relationship Map">
                    <img class="themified-white-icon customer-list-table__link-icon" src="/assets/icons/relationship-map-icon.png">
                  </a>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="customer-list-table__row" [ngClass]="{'customer-list-table__row_inactive': !row.isActiveCustomer}"></tr>
          </table>
        </div>
        <div class="table-empty" *ngIf="paginator.length === 0">
          {{ 'customer_list.message' | translate }}
        </div>
        <mat-paginator class="custom-mat-paginator" [pageSizeOptions]="[10, 20, 50]" [length]="count" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>
</div>
